function calculateDistance(element, pageX, pageY) {
  let left = element.offset().left;
  return Math.abs(pageX - left);
}

$(document).ready(function () {
  //iterate over all slick classses
  $("#shopify-section-collection span.product .slick").each(function () {
    $(this).slick({
      infinite: true,
      dots: true,
      appendDots: $(this).parent().find(".slick-dots-element")
    });
  });

  $("span.product").each(function () {
    let prevBtn = $(this).find(".imgStart");
    let nextBtn = $(this).find(".imgEnd");
    let width = $(this).width();
    let a = $(this);
    $(this).mousemove(function (e) {
      prevBtnOpacity = Math.floor(
        ((width - calculateDistance(prevBtn, e.pageX, e.pageY)) * 100) / width
      );
      nextBtnOpacity = Math.floor(
        ((width - calculateDistance(nextBtn, e.pageX, e.pageY)) * 100) / width
      );
      a[0].style.setProperty("--left-opacity", prevBtnOpacity.toString());
      a[0].style.setProperty("--right-opacity", nextBtnOpacity.toString());
    });
  });

  $("#shopify-section-collection span.product .slick.primary img").removeClass(
    "hidden"
  );
});
